module.exports = __webpack_public_path__ + "media/ไอ้หน้าหมี.d6bb87ee.mp3";